const getSockets = (envType : string | undefined) => {
    switch (envType) {
        case "dev":
            return "ws://78.24.222.80:6001"
        default:
            return "ws://localhost:6001"
    }
}

export const socketsUrl = getSockets(process.env.REACT_APP_STATUS)